<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                     
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'الحلقات'" :to="{name: 'lessons'}">الحلقات</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing"> 
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h4>
                                              <i class="flaticon-computer-4"></i> 
                                     إدارة الحلقات   
                                        </h4>
                                    </div> 
                                     <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item"><create-button  v-if="hasPermissions('lessons_create')" :routeName="'lessons.create'"></create-button></li>
                                      </ul>
                                    </div>           
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <div class="table-responsive">
                                  <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <table class="table table-bordered mb-4">
                                        <thead>
                                            <tr>
                                               <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">الاسم</th>
                                                <th @click="resortData();">المرحلة الدراسية</th>
                                                <th @click="resortData();">الصف الدراسي</th>
                                                <th @click="resortData();">الحالة</th>
                                                <th class="align-center">#</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in data.data" :key="index">
                                                <td>{{index+1}}</td>
                                                <td>{{item.name}}</td>
                                                <td>{{ item.stage ? item.stage.name : '---' }}</td>
                                                <td>{{ item.group ? item.group.name : '---' }}</td>
                                                <td>
                                                  <label v-if="item.status == 1" class="badge badge-success">نشط</label>
                                                  <label v-else class="badge badge-danger">غير نشط</label>
                                                </td>
                                                <td class="text-center">
                                                    
                                                    <div class="dropdown custom-dropdown">
                                                        <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <i class="flaticon-dot-three fs-17"></i>
                                                        </a>

                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                            <edit-button v-if="hasPermissions('lessons_edit')" :routing="{name: 'lessons.edit', params: {id: item.id}}"></edit-button>
                                                            <delete-button v-if="item.students_count == 0 && hasPermissions('lessons_delete')" :deleteUrl="'/lessons/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                            <a :title="'حذف'" href="javascript:void(0);" class="dropdown-item" v-if="item.students_count != 0 && hasPermissions('lessons_delete')"
                                                            @click.prevent="sweetAlert('لا يمكنك حذف البيانات حيث انها مرتبطة ببيانات اخرى', 'warning')"><i class="ti-trash"></i> حذف</a>
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th  @click="resortData();">الاسم</th>
                                                <th @click="resortData();">المرحلة الدراسية</th>
                                                <th @click="resortData();">الصف الدراسي</th>
                                                <th  @click="resortData();">الحالة</th>
                                                <th class="align-center">#</th>
                                            </tr>
                                        </tfoot>
                                        
                                    </table>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
            </div>


</template>
<script>

export default {
  data() {
    return {
      data: {
        data: {},
        searching:{
            id: '',
            name: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      }
    };
  },
  created(){
      this.flashAlert();
      this.getIndexData(1);
  },
  methods: {
      resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
      },
      getIndexData(page){
        this.$baseApi.get('/lessons?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
                  console.log(response.data.data)
            if(response.data.code == 200){
               this.data.paginated = response.data.data.lessons;
               this.data.data = response.data.data.lessons.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
